export default {
    SET_EVENTS (state, events) {
      state.events = events
    },
    SET_CONSULTATIONS (state, consultations){
      state.consultations = consultations
    }
}